import { Card, FooterMenu } from "components"
import { Fragment, useEffect, useState } from "react"
import { useExportPdfFindFinance, useList } from "./hooks"
import { FilterSection, TableSection } from "./components"
import { SelectedState } from "pages/FindSection/types"
import { exportExcelFindFinance } from "./functions"
import moment from "moment"

export function FindByFinance() {
  const [selected, setSelected] = useState<SelectedState>({
    date_from: moment().format("YYYY-MM-DD"),
    date_end: moment().endOf("month").format("YYYY-MM-DD"),
    search_by: "",
    search_id: ""
  })
  const exportDateFormat = `${moment(selected.date_from).format("DD/MM/YYYY")} - ${moment(selected.date_end).format("DD/MM/YYYY")}`
  const { data, isLoading, refetch } = useList()
  const exportPdf = useExportPdfFindFinance({
    data: data,
    dateFilter: exportDateFormat ?? ""
  })

  useEffect(() => {
    const filteredSelected: Partial<SelectedState> = {}

      ; (Object.keys(selected) as Array<keyof SelectedState>).forEach((key) => {
        if (selected[key]) {
          filteredSelected[key] = selected[key]
        }
      })

    refetch(filteredSelected)

    // eslint-disable-next-line
  }, [selected])

  return (
    <Fragment>
      <FilterSection selected={selected} setSelected={setSelected} />

      <section className="mt-2">
        <Card>
          <Card.Body>
            <TableSection
              data={data}
              isLoading={isLoading}
              refetch={refetch}
              selected={selected}
            />
          </Card.Body>
        </Card>
      </section>
      <FooterMenu
        export={{
          actiontype: "export",
          onClick: () =>
            exportExcelFindFinance({
              data: data,
              dateFilter: exportDateFormat
            })
        }}
        pdf={{ actiontype: "pdf", onClick: exportPdf.handleExportPdf }}
      />
    </Fragment>
  )
}
